export default class LogsProxi {
    constructor(axios, url) {
        this.axios = axios;
        this.url = url;
    }
    //-----------------------------------PUNTOS DE ATERRISAJE FOROS GENERAL-------------------------

    getAllLogin(page, take) {
        return this.axios.get(this.url + `/logs?page=${page}&take=${take}`);
    }

    removeLogsLogin(id) {
        return this.axios.delete(this.url + `/logs/${id}`);
    }

    async queryLogsLogin(querys) {
        return await this.axios.get(this.url + `/logs/query?querys=${querys}`);
    }

    getAllNotas(page, take) {
        return this.axios.get(this.url + `/logs/all?page=${page}&take=${take}`);
    }

    removeLogsNotas(id) {
        return this.axios.delete(this.url + `/logs/notas/${id}`);
    }

    async queryLogsNotas(querys) {
        return await this.axios.get(this.url + `/logs/queryNota?querys=${querys}`);
      }
}